import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faSignOutAlt, 
  faCog, 
  faTachometerAlt, 
  faFolderOpen, 
  faFileAlt,
  faUpload
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';

const TopNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout, isAuthenticated } = useAuth();

  // Check if the current path matches the nav item path
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Navbar bg="white" variant="light" expand="lg" className="shadow-sm" sticky="top">
      <Container className="py-4">
        <Navbar.Brand as={Link} to={isAuthenticated() ? '/dashboard' : '/'} className="fw-bold text-primary">
          Vcurd
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          {isAuthenticated() && (
            <Nav className="me-auto">
              <Nav.Link 
                as={Link} 
                to="/dashboard" 
                active={isActive('/dashboard')}
                className="d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
                Dashboard
              </Nav.Link>
              
              <NavDropdown 
                title={
                  <span>
                    <FontAwesomeIcon icon={faFolderOpen} className="me-2" />
                    Projects
                  </span>
                } 
                id="projects-dropdown"
                active={isActive('/projects')}
              >
                <NavDropdown.Item as={Link} to="/projects">
                  All Projects
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/projects/create">
                  Create Project
                </NavDropdown.Item>
              </NavDropdown>
              
              <NavDropdown 
                title={
                  <span>
                    <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                    Documents
                  </span>
                } 
                id="documents-dropdown"
                active={isActive('/documents')}
              >
                {/* <NavDropdown.Item as={Link} to="/documents">
                  All Documents
                </NavDropdown.Item> */}
                <NavDropdown.Item as={Link} to="/documents/upload">
                  <FontAwesomeIcon icon={faUpload} className="me-2" />
                  Upload Document
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}
          
          <Nav className="ms-auto">
            {isAuthenticated() ? (
              <NavDropdown 
                title={
                  <span>
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    {currentUser?.name || 'User'}
                  </span>
                } 
                id="user-dropdown"
                align="end"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  <FontAwesomeIcon icon={faCog} className="me-2" />
                  Profile
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">Login</Nav.Link>
                <Nav.Link as={Link} to="/register">Register</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
